/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const ISSUE_CREDENTIAL = gql`
  mutation IssueCredential(
    $email: String!
    $credentialTemplateId: String!
    $visiblity: Visiblity!
    $credentialContent: [KeyVal]
    $evidence: [Evidence]
    $sendEmail: Boolean
    $sendPn: Boolean
  ) {
    issueCredential(
      email: $email
      credentialTemplateId: $credentialTemplateId
      visiblity: $visiblity
      credentialContent: $credentialContent
      evidence: $evidence
      sendEmail: $sendEmail
      sendPN: $sendPn
    ) {
      message
    }
  }
`;
